export class SavePurchase {
  constructor(
    public amount: String = "",
    public amountTendered: String = "",
    public changes: String = "",
    public orderId: Number = null
  ) {}
}
